import React from "react";
import { I18n } from "@aws-amplify/core";
import { get, filter } from "lodash";
import Grid from "@material-ui/core/Grid";

import images from "../../../assets/img/images";

const DataPrivacyConsent = (props) => {
  const { policy, acceptances, center = false } = props;

  const acceptance = get(
    filter(
      acceptances,
      (a) => get(a, ["policy", "id"]) === get(policy, ["id"])
    ),
    [0]
  );

  return (
    <Grid
      container
      alignItems="center"
      justify={center ? "center" : "flex-start"}
    >
      {get(policy, ["compliance", "compliance"]) === "required" && (
        <Grid
          item
          className="flexCenter"
          style={{ width: "15px", marginRight: "5px" }}
        >
          <img
            src={
              get(acceptance, ["accepted"]) === true
                ? images.greenCheckmarkWhite
                : get(acceptance, ["accepted"]) === false
                  ? images.redCrossCircle
                  : images.warningTriangleOrange
            }
            height="13px"
            alt="consent_icon"
          />
        </Grid>
      )}
      <Grid item className="text-54" style={{ lineHeight: "15px" }}>
        {get(policy, ["compliance", "compliance"]) === "optional"
          ? get(acceptance, ["accepted"]) === true
            ? I18n.get("profiles_read")
            : I18n.get("profiles_toRead")
          : get(acceptance, ["accepted"]) === true
            ? I18n.get("profiles_accepted")
            : get(acceptance, ["accepted"]) === false
              ? I18n.get("profiles_refused")
              : I18n.get("profiles_pending")}
      </Grid>
    </Grid>
  );
};

export default DataPrivacyConsent;
